export enum ROUTES {
  REGISTER = 'register',
  PASSWORD = 'password',
  APP = 'app',
  MESSAGE = 'message',
  DOCUMENTS = 'documents',
}

